import { createFileRoute, redirect } from "@tanstack/react-router";
import Link from "~/components/Link";
import { Logo, LogoText } from "~/components/Logo";
import { trpcStandalone } from "~/utils/trpcStandalone";

/**
 * Root "/" — resolve the signed-in user's teams. A single-team user is bounced
 * straight to their team; otherwise a picker is shown (was (new)/page.tsx).
 */
export const Route = createFileRoute("/_authed/")({
  loader: async () => {
    const teams = await trpcStandalone.team.getTeams.query();
    if (teams.length === 1 && teams[0]?.id) {
      throw redirect({
        to: "/$teamId",
        params: { teamId: teams[0].id },
        replace: true,
      });
    }
    return { teams };
  },
  component: TeamPickerPage,
});

function TeamPickerPage() {
  const { teams } = Route.useLoaderData();
  const ts = {
    playground: teams.filter((team) => team.isPlaygroundOnly),
    regular: teams.filter((team) => !team.isPlaygroundOnly),
  };

  return (
    <div className="flex flex-col items-center pt-8">
      <nav className="flex flex-row items-center justify-between p-4">
        <a href="/" className="flex flex-row items-center gap-2">
          <Logo className="h-8 w-8" />
          <LogoText className="text-lg" />
        </a>
      </nav>

      <div className="flex flex-col items-center text-center gap-4">
        <h1 className="text-xl font-bold w-full justify-center">
          👋 Welcome, select a team to get started.
        </h1>
        <div className="overflow-auto pt-4">
          <ul className="w-full flex flex-col gap-4 pb-12">
            {ts.regular.length > 0 && (
              <>
                <h1 className="text-lg font-bold">My Teams</h1>
                {ts.regular.map((team) => (
                  <li key={team.id} className="w-full">
                    <Link
                      href={`/${team.id}`}
                      className="btn bg-white w-full justify-center btn-lg shadow-xl"
                    >
                      {team.name}
                    </Link>
                  </li>
                ))}
              </>
            )}
            {ts.playground.length > 0 && (
              <>
                <h2 className="text-lg font-bold pt-4">My Playground Teams</h2>
                {ts.playground.map((team) => (
                  <li key={team.id} className="w-full">
                    <Link
                      href={`/${team.id}`}
                      className="btn bg-white w-full justify-center btn-lg shadow-xl"
                    >
                      {team.name}
                    </Link>
                  </li>
                ))}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
